import { fromJS } from 'immutable';

import { USER_GET_LOADED } from '@uncinc/react-drupal-core/dist/redux/actions/Entity/User';
import { USER_RESET } from '../../../actions/Entity/User';

const initialState = fromJS({});

export default function user(state = initialState, action = {}) {
  switch (action.type) {
    // Cases from @uncinc/react-drupal-core
    case USER_GET_LOADED: {
      return state.set(action.user_id, fromJS(action.data));
    }

    // Custom Jellinek cases
    case USER_RESET: {
      return initialState;
    }

    default:
      return state;
  }
}
